// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `:root {
  --color: #000;
  --app-max-content-width: 1440px;
  --app-header-max-width: 1920px;
}

:root {
  --color: #000;
  --app-max-content-width: 1440px;
  --app-header-max-width: 1920px;
}

.revamp-need-help-dialog .MuiDialog-container {
  align-items: center;
  justify-content: center;
}
.revamp-need-help-dialog .MuiDialog-paper {
  border-radius: 12px;
  overflow: hidden;
}
.revamp-need-help-dialog .revamp-need-help-title {
  display: flex;
  align-items: center;
  justify-content: space-between;
  padding: 18px 24px 16px;
  font-size: 18px;
  font-weight: 400;
  color: #111827;
  line-height: 1.4;
}
.revamp-need-help-dialog .revamp-need-help-close {
  margin-left: auto;
  color: #6B7280;
}
.revamp-need-help-dialog .revamp-need-help-close:hover {
  background-color: #F3F4F6;
}
.revamp-need-help-dialog .revamp-need-help-content {
  display: flex;
  flex-direction: column;
  align-items: center;
  text-align: center;
  padding: 32px 40px 40px !important;
}
.revamp-need-help-dialog .revamp-need-help-illustration {
  margin-bottom: 28px;
}
.revamp-need-help-dialog .revamp-need-help-illustration img {
  width: 260px;
  max-width: 100%;
  display: block;
}
.revamp-need-help-dialog .revamp-need-help-text {
  font-size: 15px;
  color: #374151;
  margin-bottom: 10px;
  font-weight: 400;
}
.revamp-need-help-dialog .revamp-need-help-email {
  font-size: 15px;
  font-weight: 500;
  color: #2563EB !important;
  text-decoration: none;
}
.revamp-need-help-dialog .revamp-need-help-email:hover {
  text-decoration: underline;
}

.revamp-more-menu .MuiPaper-root {
  border-radius: 12px;
  box-shadow: 0px 8px 24px rgba(0, 0, 0, 0.1);
  min-width: 200px;
  margin-top: 6px;
  border: 1px solid #EBEBEB;
  padding: 8px 0;
}
.revamp-more-menu .revamp-more-menu-item {
  display: flex;
  align-items: center;
  gap: 12px;
  padding: 10px 20px;
  cursor: pointer;
  transition: background 0.15s ease;
}
.revamp-more-menu .revamp-more-menu-item .more-menu-icon-wrap {
  width: 22px;
  height: 22px;
  display: flex;
  align-items: center;
  justify-content: center;
  flex-shrink: 0;
}
.revamp-more-menu .revamp-more-menu-item .more-menu-icon-wrap svg, .revamp-more-menu .revamp-more-menu-item .more-menu-icon-wrap img {
  width: 20px;
  height: 20px;
  color: #6B7280;
}
.revamp-more-menu .revamp-more-menu-item .more-menu-icon-wrap svg path, .revamp-more-menu .revamp-more-menu-item .more-menu-icon-wrap img path {
  fill: #6B7280;
}
.revamp-more-menu .revamp-more-menu-item .MuiTypography-root {
  font-size: 14px;
  font-weight: 400;
  color: #3D3D42;
  line-height: 1.4;
}
.revamp-more-menu .revamp-more-menu-item:hover {
  background-color: #F5F6F8;
}

.app-bar .MuiInputBase-root .MuiSelect-select {
  color: #fff !important;
}
.app-bar .MuiInputBase-root .MuiSvgIcon-root.MuiSelect-icon {
  color: #fff;
}

.revamp-bell-wrap.MuiButtonBase-root {
  width: 32px;
  height: 32px;
  border-radius: 64px;
  background: rgba(10, 10, 10, 0.05);
  padding: 0;
}
.revamp-bell-wrap.MuiButtonBase-root:hover {
  background: #F5F6F8 !important;
}

.revamp-notifications-popover .revamp-notifications-paper {
  width: 360px;
  max-height: min(600px, 100vh - 92px);
  overflow: hidden;
  border: 1px solid #D7DAE3;
  box-shadow: 0px 22px 44px rgba(16, 24, 40, 0.22);
  margin-top: 8px;
  background: #FFF;
  padding: 10px;
  border-radius: 8px;
}

.revamp-notifications-header {
  display: flex;
  align-items: center;
  justify-content: space-between;
  padding: 0px 10px;
  border-bottom: 2px solid #0066F4;
}
.revamp-notifications-header .title {
  font-size: 18px;
  line-height: 1.2;
  font-weight: 600;
  color: #090B13;
}
.revamp-notifications-header .close-btn {
  width: 36px;
  height: 36px;
  color: #1F2937;
  cursor: pointer;
}
.revamp-notifications-header .close-btn:hover {
  background-color: rgba(17, 24, 39, 0.08);
}

.revamp-notifications-subheader {
  display: flex;
  align-items: center;
  justify-content: space-between;
  margin: 12px 0 8px;
}
.revamp-notifications-subheader .subheader-title {
  font-size: 14px;
  font-weight: 600;
  color: #10131F;
  line-height: 1.2;
}
.revamp-notifications-subheader .mark-all-read-btn {
  appearance: none;
  border: 0;
  background: transparent;
  font-size: 14px;
  font-weight: 400;
  color: #3D3D42;
  cursor: pointer;
  line-height: 1.2;
  padding: 0;
}
.revamp-notifications-subheader .mark-all-read-btn:hover {
  color: #20285C;
  text-decoration: underline;
}

.revamp-notifications-content {
  max-height: calc(min(600px, 100vh - 92px) - 90px);
  overflow-y: auto;
  display: flex;
  flex-direction: column;
}

.revamp-notification-top-actions {
  display: flex;
  justify-content: flex-end;
  padding: 12px 0 12px;
}
.revamp-notification-top-actions .mark-all-read {
  appearance: none;
  border: 0;
  background: transparent;
  font-size: 14px;
  line-height: 1.2;
  font-weight: 400;
  color: #3D3D42;
  cursor: pointer;
}
.revamp-notification-top-actions .mark-all-read:hover {
  color: #20285C;
  text-decoration: underline;
}

.revamp-announcement-list {
  display: flex;
  flex-direction: column;
  gap: 12px;
  flex: 1;
  min-height: 0;
  overflow: auto;
}

.revamp-announcement-card {
  background: #FFFFFF;
  border: 1px solid #E2E4E8;
  border-radius: 6px;
  padding: 12px;
  transition: box-shadow 0.18s ease, border-color 0.18s ease;
}
.revamp-announcement-card:hover {
  border-color: #B7BDCC;
  box-shadow: 0px 8px 20px rgba(15, 23, 42, 0.08);
}
.revamp-announcement-card .badge-row {
  display: flex;
  justify-content: space-between;
  align-items: center;
  margin-bottom: 14px;
}
.revamp-announcement-card .badge {
  font-size: 12px;
  font-weight: 600;
  line-height: 1;
  color: #2E75B6;
  background: rgba(46, 117, 182, 0.12);
  border-radius: 999px;
  padding: 8px 10px;
}
.revamp-announcement-card .unread-dot {
  width: 10px;
  height: 10px;
  border-radius: 50%;
  background: #10131F;
  flex-shrink: 0;
}
.revamp-announcement-card .announcement-title {
  font-size: 14px;
  line-height: 1.25;
  font-weight: 600;
  color: #20242E;
  margin-bottom: 10px;
}
.revamp-announcement-card .announcement-description {
  font-size: 12px;
  line-height: 1.3;
  color: #2A303D;
  margin-bottom: 16px;
}
.revamp-announcement-card .announcement-footer {
  display: flex;
  justify-content: space-between;
  align-items: center;
  gap: 10px;
}
.revamp-announcement-card .announcement-time {
  font-size: 12px;
  line-height: 1.2;
  color: #6B7280;
  font-weight: 400;
}
.revamp-announcement-card .learn-more-btn {
  appearance: none;
  border: 0;
  background: transparent;
  font-size: 12px;
  line-height: 1.1;
  color: #2E75B6;
  font-weight: 600;
  cursor: pointer;
  display: inline-flex;
  align-items: center;
  gap: 8px;
}
.revamp-announcement-card .learn-more-btn .arrow {
  font-size: 14px;
  line-height: 1;
  transition: transform 0.16s ease;
}
.revamp-announcement-card .learn-more-btn:hover {
  color: #1D5F99;
}
.revamp-announcement-card .learn-more-btn:hover .arrow {
  transform: translateX(3px);
}

.revamp-announcement-card.revamp-announcement-empty {
  min-height: 140px;
  display: flex;
  align-items: center;
  justify-content: center;
  text-align: center;
  background: none;
  border: none;
}
.revamp-announcement-card.revamp-announcement-empty .announcement-title {
  margin-bottom: 0;
  color: #5F667A;
  font-weight: 500;
}

@media screen and (max-width: 900px) {
  .revamp-notifications-popover .revamp-notifications-paper {
    width: min(360px, 100vw - 24px);
    max-height: min(500px, 100vh - 120px);
    height: auto;
    right: 8px !important;
    left: auto !important;
    margin-top: 6px;
    margin-left: 0;
  }
  .revamp-notifications-header {
    padding: 10px 12px;
  }
  .revamp-notifications-header .title {
    font-size: 16px;
  }
  .revamp-notifications-subheader {
    margin: 10px 12px 8px;
  }
  .revamp-notifications-subheader .subheader-title {
    font-size: 14px;
  }
  .revamp-notifications-subheader .mark-all-read-btn {
    font-size: 14px;
  }
  .revamp-notifications-content {
    padding: 0 12px 12px;
    max-height: min(340px, 100vh - 240px);
  }
  .revamp-announcement-card {
    padding: 12px;
  }
  .revamp-announcement-card .badge {
    font-size: 12px;
    padding: 4px 8px;
  }
  .revamp-announcement-card .unread-dot {
    width: 10px;
    height: 10px;
  }
  .revamp-announcement-card .announcement-title {
    font-size: 14px;
    margin-bottom: 6px;
  }
  .revamp-announcement-card .announcement-description {
    font-size: 14px;
    margin-bottom: 10px;
  }
  .revamp-announcement-card .announcement-time {
    font-size: 12px;
  }
  .revamp-announcement-card .learn-more-btn {
    font-size: 14px;
  }
  .revamp-announcement-card .learn-more-btn .arrow {
    font-size: 16px;
  }
}`, "",{"version":3,"sources":["webpack://./src/assets/scss/variable.scss","webpack://./src/assets/scss/appBar.scss"],"names":[],"mappings":"AAAA;EACI,aAAA;EAKA,+BAAA;EAMA,8BAAA;ACRJ;;ADJA;EACI,aAAA;EAKA,+BAAA;EAMA,8BAAA;ACFJ;;AALE;EACE,mBAAA;EACA,uBAAA;AAQJ;AALE;EACE,mBAAA;EACA,gBAAA;AAOJ;AAJE;EACE,aAAA;EACA,mBAAA;EACA,8BAAA;EACA,uBAAA;EACA,eAAA;EACA,gBAAA;EACA,cAAA;EACA,gBAAA;AAMJ;AAHE;EACE,iBAAA;EACA,cAAA;AAKJ;AAHI;EACE,yBAAA;AAKN;AADE;EACE,aAAA;EACA,sBAAA;EACA,mBAAA;EACA,kBAAA;EACA,kCAAA;AAGJ;AAAE;EACE,mBAAA;AAEJ;AAAI;EACE,YAAA;EACA,eAAA;EACA,cAAA;AAEN;AAEE;EACE,eAAA;EACA,cAAA;EACA,mBAAA;EACA,gBAAA;AAAJ;AAGE;EACE,eAAA;EACA,gBAAA;EACA,yBAAA;EACA,qBAAA;AADJ;AAGI;EACE,0BAAA;AADN;;AAQE;EACE,mBAAA;EACA,2CAAA;EACA,gBAAA;EACA,eAAA;EACA,yBAAA;EACA,cAAA;AALJ;AAQE;EACE,aAAA;EACA,mBAAA;EACA,SAAA;EACA,kBAAA;EACA,eAAA;EACA,iCAAA;AANJ;AAQI;EACE,WAAA;EACA,YAAA;EACA,aAAA;EACA,mBAAA;EACA,uBAAA;EACA,cAAA;AANN;AAQM;EACE,WAAA;EACA,YAAA;EACA,cAAA;AANR;AAOQ;EAAO,aAAA;AAJf;AAQI;EACE,eAAA;EACA,gBAAA;EACA,cAAA;EACA,gBAAA;AANN;AASI;EACE,yBAAA;AAPN;;AAcQ;EACI,sBAAA;AAXZ;AAeY;EACI,WAAA;AAbhB;;AAqBE;EACE,WAAA;EACA,YAAA;EACA,mBAAA;EACA,kCAAA;EACA,UAAA;AAlBJ;AAoBI;EACE,8BAAA;AAlBN;;AAwBE;EACE,YAAA;EACA,oCAAA;EACA,gBAAA;EACA,yBAAA;EACA,gDAAA;EACA,eAAA;EACA,gBAAA;EACA,aAAA;EACA,kBAAA;AArBJ;;AAyBA;EACE,aAAA;EACA,mBAAA;EACA,8BAAA;EACA,iBAAA;EACA,gCAAA;AAtBF;AAwBE;EACE,eAAA;EACA,gBAAA;EACA,gBAAA;EACA,cAAA;AAtBJ;AAyBE;EACE,WAAA;EACA,YAAA;EACA,cAAA;EACA,eAAA;AAvBJ;AAyBI;EACE,wCAAA;AAvBN;;AA4BA;EACE,aAAA;EACA,mBAAA;EACA,8BAAA;EACA,kBAAA;AAzBF;AA2BE;EACE,eAAA;EACA,gBAAA;EACA,cAAA;EACA,gBAAA;AAzBJ;AA4BE;EACE,gBAAA;EACA,SAAA;EACA,uBAAA;EACA,eAAA;EACA,gBAAA;EACA,cAAA;EACA,eAAA;EACA,gBAAA;EACA,UAAA;AA1BJ;AA4BI;EACE,cAAA;EACA,0BAAA;AA1BN;;AA+BA;EACE,iDAAA;EACA,gBAAA;EACA,aAAA;EACA,sBAAA;AA5BF;;AA+BA;EACE,aAAA;EACA,yBAAA;EACA,oBAAA;AA5BF;AA8BE;EACE,gBAAA;EACA,SAAA;EACA,uBAAA;EACA,eAAA;EACA,gBAAA;EACA,gBAAA;EACA,cAAA;EACA,eAAA;AA5BJ;AA8BI;EACE,cAAA;EACA,0BAAA;AA5BN;;AAiCA;EACE,aAAA;EACA,sBAAA;EACA,SAAA;EACA,OAAA;EACA,aAAA;EACA,cAAA;AA9BF;;AAiCA;EACE,mBAAA;EACA,yBAAA;EACA,kBAAA;EACA,aAAA;EACA,0DAAA;AA9BF;AAgCE;EACE,qBAAA;EACA,+CAAA;AA9BJ;AAiCE;EACE,aAAA;EACA,8BAAA;EACA,mBAAA;EACA,mBAAA;AA/BJ;AAkCE;EACE,eAAA;EACA,gBAAA;EACA,cAAA;EACA,cAAA;EACA,oCAAA;EACA,oBAAA;EACA,iBAAA;AAhCJ;AAmCE;EACE,WAAA;EACA,YAAA;EACA,kBAAA;EACA,mBAAA;EACA,cAAA;AAjCJ;AAoCE;EACE,eAAA;EACA,iBAAA;EACA,gBAAA;EACA,cAAA;EACA,mBAAA;AAlCJ;AAqCE;EACE,eAAA;EACA,gBAAA;EACA,cAAA;EACA,mBAAA;AAnCJ;AAsCE;EACE,aAAA;EACA,8BAAA;EACA,mBAAA;EACA,SAAA;AApCJ;AAuCE;EACE,eAAA;EACA,gBAAA;EACA,cAAA;EACA,gBAAA;AArCJ;AAwCE;EACE,gBAAA;EACA,SAAA;EACA,uBAAA;EACA,eAAA;EACA,gBAAA;EACA,cAAA;EACA,gBAAA;EACA,eAAA;EACA,oBAAA;EACA,mBAAA;EACA,QAAA;AAtCJ;AAwCI;EACE,eAAA;EACA,cAAA;EACA,gCAAA;AAtCN;AAyCI;EACE,cAAA;AAvCN;AAyCM;EACE,0BAAA;AAvCR;;AA6CA;EACE,iBAAA;EACA,aAAA;EACA,mBAAA;EACA,uBAAA;EACA,kBAAA;EACA,gBAAA;EACA,YAAA;AA1CF;AAiDE;EACE,gBAAA;EACA,cAAA;EACA,gBAAA;AA/CJ;;AAmDA;EAEI;IACE,+BAAA;IACA,qCAAA;IACA,YAAA;IACA,qBAAA;IACA,qBAAA;IACA,eAAA;IACA,cAAA;EAjDJ;EAqDA;IACE,kBAAA;EAnDF;EAqDE;IACE,eAAA;EAnDJ;EAuDA;IACE,qBAAA;EArDF;EAuDE;IACE,eAAA;EArDJ;EAwDE;IACE,eAAA;EAtDJ;EA0DA;IACE,oBAAA;IACA,qCAAA;EAxDF;EA2DA;IACE,aAAA;EAzDF;EA2DE;IACE,eAAA;IACA,gBAAA;EAzDJ;EA4DE;IACE,WAAA;IACA,YAAA;EA1DJ;EA6DE;IACE,eAAA;IACA,kBAAA;EA3DJ;EA8DE;IACE,eAAA;IACA,mBAAA;EA5DJ;EA+DE;IACE,eAAA;EA7DJ;EAgEE;IACE,eAAA;EA9DJ;EAgEI;IACE,eAAA;EA9DN;AACF","sourcesContent":[":root {\n    --color: #000;\n    // --font-family: \"sans-serif\";\n    // Single source of truth for the app's max BODY content width (page content + non-dashboard\n    // footers, e.g. the createApplication sticky footer). Change this value to resize that column.\n    // See .app-content-shell in form_styles.scss, which reads this variable.\n    --app-max-content-width: 1440px;\n    // Caps the header's CONTENT (.revamp-header in dashboard.scss) and the Dashboard-page footer\n    // (.version-wrapper-dashboard) / IndeterminateLoadingBar.tsx, all of which center/cap at this\n    // width. .revamp-appbar itself (the header's background) stays full viewport width regardless\n    // — it does not read this variable — so the bar's background spans edge-to-edge while its\n    // content stays capped and centered inside it.\n    --app-header-max-width: 1920px;\n}\n\n// Color codes\n// $primary_color: #054E5A;\n$primary_color:  var(--color);\n$page_bg: #F7F7F8;\n$quote-bgColor:#EAF3F5;\n$accordion-bgColor:#F5F6F8;\n$grey_color: #A3A9B9;\n$light_black: #14151C;\n$input_text: #696F88;\n$light_bgcolor: #F3F4F6;\n$color: #A3A9B9;\n$error: #D84315;\n$white_color: #fff;\n$light_background: #F3F4F6;\n$light_border_color: #C2C7D0;\n$label_color: #808080;\n$light_gray:#718899;\n$icon_bg:#DDDEE9;\n$header_bgcolor: #DFE2E7;\n$table_border:#D9D9D9;\n$cards_bg:#F9F9F9;\n$bg_text:#666;\n//Font Family\n$primaryFont:var(--font-family);\n// Font sizes   \n$font_10: 10px;\n$font_11: 11px;\n$font_12: 12px;\n$font_13: 13px;\n$font_14: 14px;\n$font_15: 15px;\n$font_16: 16px;\n$font_18: 18px;\n$font_20: 20px;\n$font_21: 21px;\n$font_22: 22px;\n$font_24: 24px;\n$font_25: 25px;\n$font_26: 26px;\n$font_28: 28px;\n$font_29: 29px;\n$font_30: 30px;\n\n// Font weights\n$font_weight_normal: normal;\n$font_weight_bold: bold;\n$font_weight_medium: Medium;\n$font_weight_300: 300;\n$font_weight_500: 500;\n$font_weight_600: 600;\n$font_weight_700: 700;\n\n// Font Family\n// $robot: 'robotoregular';\n\n// Box shadow\n$box_shadow_1: 0 1px 3px 0 rgba(63, 63, 68, 0.15),\n    0 0 0 1px rgba(63, 63, 68, 0.05);\n$box_shadow_2: 0 0 7px 0 rgba(0, 0, 0, 0.23);\n$box_shadow_3: 0 0 6px 0 rgba(0, 0, 0, 0.27);\n$box_shadow_4: 0 0 0 1px #e4e7eb;\n$box_shadow_5: 0 0 15px 0 rgba(0, 0, 0, 0.23);\n$box_shadow_1: 0 4px 6px 0 rgba(0, 0, 0, 0.06);\n$box_shadow: 2px 4px 16px rgba(50, 98, 149, 0.15);\n\n//Border radius\n$border_4: 4px;\n$border_10: 10px;\n$border_15: 15px;\n$border_100: 100%;\n\n///margin scss \n//------------------\n$margin-5: 5px 5px 5px 5px;\n$margin-10: 10px 10px 10px 10px;\n$margin-15: 15px 15px 15px 15px;\n$margin-10-15: 10px 15px 10px 15px;\n\n//Media quries\n$mobile_breakpoint: 576px;\n$tablet_breakpoint: 768px;\n$laptop_breakpoint: 992px;\n$large_laptop_breakpoint: 1280px;\n$desktop_breakpoint: 1440px;\n$desktop_point: 1024px;","@import './mixins.scss';\n@import './variable.scss';\n\n// ─── Need Help dialog ─────────────────────────────────────────────────────────\n.revamp-need-help-dialog {\n  .MuiDialog-container {\n    align-items: center;\n    justify-content: center;\n  }\n\n  .MuiDialog-paper {\n    border-radius: 12px;\n    overflow: hidden;\n  }\n\n  .revamp-need-help-title {\n    display: flex;\n    align-items: center;\n    justify-content: space-between;\n    padding: 18px 24px 16px;\n    font-size: 18px;\n    font-weight: 400;\n    color: #111827;\n    line-height: 1.4;\n  }\n\n  .revamp-need-help-close {\n    margin-left: auto;\n    color: #6B7280;\n\n    &:hover {\n      background-color: #F3F4F6;\n    }\n  }\n\n  .revamp-need-help-content {\n    display: flex;\n    flex-direction: column;\n    align-items: center;\n    text-align: center;\n    padding: 32px 40px 40px !important;\n  }\n\n  .revamp-need-help-illustration {\n    margin-bottom: 28px;\n\n    img {\n      width: 260px;\n      max-width: 100%;\n      display: block;\n    }\n  }\n\n  .revamp-need-help-text {\n    font-size: 15px;\n    color: #374151;\n    margin-bottom: 10px;\n    font-weight: 400;\n  }\n\n  .revamp-need-help-email {\n    font-size: 15px;\n    font-weight: 500;\n    color: #2563EB !important;\n    text-decoration: none;\n\n    &:hover {\n      text-decoration: underline;\n    }\n  }\n}\n\n// ─── More dropdown menu ────────────────────────────────────────────────────────\n.revamp-more-menu {\n  .MuiPaper-root {\n    border-radius: 12px;\n    box-shadow: 0px 8px 24px rgba(0, 0, 0, 0.10);\n    min-width: 200px;\n    margin-top: 6px;\n    border: 1px solid #EBEBEB;\n    padding: 8px 0;\n  }\n\n  .revamp-more-menu-item {\n    display: flex;\n    align-items: center;\n    gap: 12px;\n    padding: 10px 20px;\n    cursor: pointer;\n    transition: background 0.15s ease;\n\n    .more-menu-icon-wrap {\n      width: 22px;\n      height: 22px;\n      display: flex;\n      align-items: center;\n      justify-content: center;\n      flex-shrink: 0;\n\n      svg, img {\n        width: 20px;\n        height: 20px;\n        color: #6B7280;\n        path { fill: #6B7280; }\n      }\n    }\n\n    .MuiTypography-root {\n      font-size: 14px;\n      font-weight: 400;\n      color: #3D3D42;\n      line-height: 1.4;\n    }\n\n    &:hover {\n      background-color: #F5F6F8;\n    }\n  }\n}\n\n.app-bar {\n    .MuiInputBase-root {\n        .MuiSelect-select {\n            color: #fff !important;\n        }\n\n        .MuiSvgIcon-root {\n            &.MuiSelect-icon {\n                color: #fff;\n            }\n        }\n    }\n}\n\n// ─── Notifications popup ──────────────────────────────────────────────────────\n.revamp-bell-wrap {\n  &.MuiButtonBase-root {\n    width: 32px;\n    height: 32px;\n    border-radius: 64px;\n    background: rgba(10, 10, 10, 0.05);\n    padding: 0;\n\n    &:hover {\n      background: #F5F6F8 !important;\n    }\n  }\n}\n\n.revamp-notifications-popover {\n  .revamp-notifications-paper {\n    width: 360px;\n    max-height: min(600px, calc(100vh - 92px));\n    overflow: hidden;\n    border: 1px solid #D7DAE3;\n    box-shadow: 0px 22px 44px rgba(16, 24, 40, 0.22);\n    margin-top: 8px;\n    background: #FFF;\n    padding: 10px;\n    border-radius: 8px;\n  }\n}\n\n.revamp-notifications-header {\n  display: flex;\n  align-items: center;\n  justify-content: space-between;\n  padding: 0px 10px;\n  border-bottom: 2px solid #0066F4;\n\n  .title {\n    font-size: 18px;\n    line-height: 1.2;\n    font-weight: 600;\n    color: #090B13;\n  }\n\n  .close-btn {\n    width: 36px;\n    height: 36px;\n    color: #1F2937;\n    cursor: pointer;\n\n    &:hover {\n      background-color: rgba(17, 24, 39, 0.08);\n    }\n  }\n}\n\n.revamp-notifications-subheader {\n  display: flex;\n  align-items: center;\n  justify-content: space-between;\n  margin: 12px 0 8px;\n\n  .subheader-title {\n    font-size: 14px;\n    font-weight: 600;\n    color: #10131F;\n    line-height: 1.2;\n  }\n\n  .mark-all-read-btn {\n    appearance: none;\n    border: 0;\n    background: transparent;\n    font-size: 14px;\n    font-weight: 400;\n    color: #3D3D42;\n    cursor: pointer;\n    line-height: 1.2;\n    padding: 0;\n\n    &:hover {\n      color: #20285C;\n      text-decoration: underline;\n    }\n  }\n}\n\n.revamp-notifications-content {\n  max-height: calc(min(600px, 100vh - 92px) - 90px);\n  overflow-y: auto;\n  display: flex;\n  flex-direction: column;\n}\n\n.revamp-notification-top-actions {\n  display: flex;\n  justify-content: flex-end;\n  padding: 12px 0 12px;\n\n  .mark-all-read {\n    appearance: none;\n    border: 0;\n    background: transparent;\n    font-size: 14px;\n    line-height: 1.2;\n    font-weight: 400;\n    color: #3D3D42;\n    cursor: pointer;\n\n    &:hover {\n      color: #20285C;\n      text-decoration: underline;\n    }\n  }\n}\n\n.revamp-announcement-list {\n  display: flex;\n  flex-direction: column;\n  gap: 12px;\n  flex: 1;\n  min-height: 0;\n  overflow: auto;\n}\n\n.revamp-announcement-card {\n  background: #FFFFFF;\n  border: 1px solid #E2E4E8;\n  border-radius: 6px;\n  padding: 12px;\n  transition: box-shadow 0.18s ease, border-color 0.18s ease;\n\n  &:hover {\n    border-color: #B7BDCC;\n    box-shadow: 0px 8px 20px rgba(15, 23, 42, 0.08);\n  }\n\n  .badge-row {\n    display: flex;\n    justify-content: space-between;\n    align-items: center;\n    margin-bottom: 14px;\n  }\n\n  .badge {\n    font-size: 12px;\n    font-weight: 600;\n    line-height: 1;\n    color: #2E75B6;\n    background: rgba(46, 117, 182, 0.12);\n    border-radius: 999px;\n    padding: 8px 10px;\n  }\n\n  .unread-dot {\n    width: 10px;\n    height: 10px;\n    border-radius: 50%;\n    background: #10131F;\n    flex-shrink: 0;\n  }\n\n  .announcement-title {\n    font-size: 14px;\n    line-height: 1.25;\n    font-weight: 600;\n    color: #20242E;\n    margin-bottom: 10px;\n  }\n\n  .announcement-description {\n    font-size: 12px;\n    line-height: 1.3;\n    color: #2A303D;\n    margin-bottom: 16px;\n  }\n\n  .announcement-footer {\n    display: flex;\n    justify-content: space-between;\n    align-items: center;\n    gap: 10px;\n  }\n\n  .announcement-time {\n    font-size: 12px;\n    line-height: 1.2;\n    color: #6B7280;\n    font-weight: 400;\n  }\n\n  .learn-more-btn {\n    appearance: none;\n    border: 0;\n    background: transparent;\n    font-size: 12px;\n    line-height: 1.1;\n    color: #2E75B6;\n    font-weight: 600;\n    cursor: pointer;\n    display: inline-flex;\n    align-items: center;\n    gap: 8px;\n\n    .arrow {\n      font-size: 14px;\n      line-height: 1;\n      transition: transform 0.16s ease;\n    }\n\n    &:hover {\n      color: #1D5F99;\n\n      .arrow {\n        transform: translateX(3px);\n      }\n    }\n  }\n}\n\n.revamp-announcement-card.revamp-announcement-empty {\n  min-height: 140px;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  text-align: center;\n  background: none;\n  border: none;\n\n  // &:hover {\n  //   border-color: #D3D6DF;\n  //   box-shadow: none;\n  // }\n\n  .announcement-title {\n    margin-bottom: 0;\n    color: #5F667A;\n    font-weight: 500;\n  }\n}\n\n@media screen and (max-width: 900px) {\n  .revamp-notifications-popover {\n    .revamp-notifications-paper {\n      width: min(360px, calc(100vw - 24px));\n      max-height: min(500px, calc(100vh - 120px));\n      height: auto;\n      right: 8px !important;\n      left: auto !important;\n      margin-top: 6px;\n      margin-left: 0;\n    }\n  }\n\n  .revamp-notifications-header {\n    padding: 10px 12px;\n\n    .title {\n      font-size: 16px;\n    }\n  }\n\n  .revamp-notifications-subheader {\n    margin: 10px 12px 8px;\n\n    .subheader-title {\n      font-size: 14px;\n    }\n\n    .mark-all-read-btn {\n      font-size: 14px;\n    }\n  }\n\n  .revamp-notifications-content {\n    padding: 0 12px 12px;\n    max-height: min(340px, calc(100vh - 240px));\n  }\n\n  .revamp-announcement-card {\n    padding: 12px;\n\n    .badge {\n      font-size: 12px;\n      padding: 4px 8px;\n    }\n\n    .unread-dot {\n      width: 10px;\n      height: 10px;\n    }\n\n    .announcement-title {\n      font-size: 14px;\n      margin-bottom: 6px;\n    }\n\n    .announcement-description {\n      font-size: 14px;\n      margin-bottom: 10px;\n    }\n\n    .announcement-time {\n      font-size: 12px;\n    }\n\n    .learn-more-btn {\n      font-size: 14px;\n\n      .arrow {\n        font-size: 16px;\n      }\n    }\n  }\n}"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
